import { Alert, Button, Table } from "react-bootstrap";
import Scaling from "../Scaling.component";
import Modal from "./Modal.component";

import { ReactComponent as EditIcon } from "../Icons/pencil2.svg";
import { ReactComponent as TrashIcon } from "../Icons/trash.svg";

import ConfirmDelete from "./ConfirmDelete.component";
import { useDeleteScaleIn, useDeleteScaleOut } from "../../hooks/useTrades";

function ScaleTable({ type, scales, tradeId, ticker }) {
  const { isDeletingIn, deleteScaleIn } = useDeleteScaleIn();
  const { isDeletingOut, deleteScaleOut } = useDeleteScaleOut();
  const isDeleting = isDeletingIn || isDeletingOut;

  const handleDelete = (data) => {
    if (type === "in") {
      deleteScaleIn(data);
    } else {
      deleteScaleOut(data);
    }
  };

  if (scales.length === 0) return null;

  return (
    <div className="mt-5">
      <h4>Scales {type}</h4>
      <Table striped bordered>
        <thead>
          <tr>
            <th>Date</th>
            {type !== "in" && <th>Entry Price</th>}
            <th>{type === "in" ? "Entry Price" : "Exit Price"} </th>
            <th>Quantity</th>
            {type !== "in" && <th>Net profit/loss</th>}
            <th>Edit </th>
          </tr>
        </thead>
        <tbody>
          {scales.map((scale, i) => {
            return (
              <tr key={i}>
                <td>{scale.date?.split("T")[0]}</td>
                {type !== "in" && <td>{scale.entryPrice}</td>}
                <td>{scale.price}</td>
                <td>{scale.quantity}</td>
                {type !== "in" && (
                  <td className={scale.profit < 0 ? "text-danger" : "text-success"}>{scale.profit.toFixed(2)}</td>
                )}
                <td className="d-flex gap-2">
                  <Modal>
                    <Modal.Open opens="Edit-scale">
                      <Button variant="outline-secondary" size="sm">
                        <EditIcon />
                      </Button>
                    </Modal.Open>
                    <Modal.Window name="Edit-scale">
                      <Scaling type={`Edit scale ${type}`} tradeId={tradeId} ticker={ticker} scaleToEdit={scale} />
                    </Modal.Window>
                  </Modal>
                  <Modal>
                    <Modal.Open opens="Delete-Trade">
                      <Button variant="outline-danger" size="sm">
                        <TrashIcon />
                      </Button>
                    </Modal.Open>
                    <Modal.Window name="Delete-Trade">
                      <ConfirmDelete
                        resourceName={scale.ticker}
                        onConfirm={() => handleDelete({ scaleId: scale._id, tradeId })}
                        disabled={isDeleting}
                      />
                    </Modal.Window>
                  </Modal>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

export default ScaleTable;
